<template>
	<div class="component social-share">
		<button
			type="button"
			class="social-share__button"
			:class="platform"
			v-for="platform in platforms"
			:key="platform"
			:aria-label="getPlatformLabel(platform)"
			:title="getPlatformLabel(platform)"
			@click="share(platform)"
		>
			<span class="social-share__icon" :uk-icon="'icon: ' + getIconName(platform)" aria-hidden="true"></span>
		</button>
	</div>
</template>

<script>
export default {
	name: 'SocialShare',
	props: {
		url: {
			type: String,
			default: () => window.location.href,
		},
		title: {
			type: String,
			default: '',
		},
		platforms: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		share(platform) {
			
			const component = this;
			const encodedUrl = encodeURIComponent(this.url);
			const encodedTitle = encodeURIComponent(this.title);
			let shareUrl = '';

			switch (platform) {
				case 'facebook':
					shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
					break;
				case 'x':
					shareUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
					break;
				case 'linkedin':
					shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}`;
					break;
				case 'whatsapp':
					shareUrl = `https://api.whatsapp.com/send?text=${encodedTitle} ${encodedUrl}`;
					break;
				case 'link': 
					component.copyToClipboard();
					return;
				case 'email':
					shareUrl = `mailto:?subject=${encodedTitle}&body=${encodedUrl}`;
					window.location.href = shareUrl;
					return;
				default:
					console.error('Unsupported platform');
					return;
			}

			window.open(shareUrl, '_blank', 'noopener,noreferrer');
		},
		getIconName(platform) {
			const platformIcons = {
				facebook: 'facebook',
				x: 'x',
				linkedin: 'linkedin',
				whatsapp: 'whatsapp',
				email: 'mail',
				link: 'link'
			};
			return platformIcons[platform] || 'question';
		},
		getPlatformLabel(platform) {
			const labels = {
				facebook: 'Delen op Facebook',
				x: 'Delen op X',
				linkedin: 'Delen op LinkedIn',
				whatsapp: 'Delen via WhatsApp',
				email: 'Delen via e-mail',
				link: 'Link kopiëren',
			};

			return labels[platform] || 'Delen';
		},
		async copyToClipboard() {
			try {
				await navigator.clipboard.writeText(this.url);
				UIkit.modal.alert('URL naar clipboard gekopieerd')
			} catch (err) {
				console.error('Failed to copy: ', err);
			}
		},
	},
};
</script>

<style scoped>
.component.social-share {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;
}
.social-share__button {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 42px;
	height: 42px;
	padding: 0;
	border: 1px solid transparent;
	border-radius: 10px;
	font: inherit;
	cursor: pointer;
	transition: transform 0.16s ease, background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}
.social-share__button:hover,
.social-share__button:focus-visible {
	transform: translateY(-1px);
	outline: none;
}
.social-share__icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
}
.social-share__icon :deep(svg) {
	width: 19px;
	height: 19px;
}
.social-share__button.facebook {
	border-color: rgba(24, 119, 242, 0.2);
	background: rgba(24, 119, 242, 0.1);
	color: #1877f2;
}
.social-share__button.x {
	border-color: rgba(20, 23, 26, 0.16);
	background: rgba(20, 23, 26, 0.08);
	color: #14171a;
}
.social-share__button.whatsapp {
	border-color: rgba(22, 163, 74, 0.2);
	background: rgba(37, 211, 102, 0.11);
	color: #149647;
}
.social-share__button.link {
	border-color: rgba(255, 61, 0, 0.2);
	background: rgba(255, 61, 0, 0.08);
	color: #e63800;
}
.social-share__button.facebook:hover,
.social-share__button.facebook:focus-visible {
	background: #1877f2;
	color: #fff;
}
.social-share__button.x:hover,
.social-share__button.x:focus-visible {
	background: #14171a;
	color: #fff;
}
.social-share__button.whatsapp:hover,
.social-share__button.whatsapp:focus-visible {
	background: #25d366;
	color: #0b321c;
}
.social-share__button.link:hover,
.social-share__button.link:focus-visible {
	background: #ff3d00;
	color: #fff;
}
:global(body.dark .social-share__button.x) {
	border-color: rgba(255, 255, 255, 0.14);
	background: rgba(255, 255, 255, 0.07);
	color: #f2f4f7;
}
</style>
